// bill-of-landing.service.ts
// Empty Angular service stub

import { BaseCrudService } from "src/app/services/apps/generic/base.service";
import {
  IBillOfLandingCreateDTO,
  IBillOfLandingGetDTO,
  IBillOfLandingUpdateDTO,
} from "./models";
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
@Injectable({
  providedIn: "root",
})
export class BillOfLandingService extends BaseCrudService<
  IBillOfLandingGetDTO,
  IBillOfLandingCreateDTO,
  IBillOfLandingUpdateDTO,
  string
> {
  constructor() {
    super(environment.endpoints.bill_of_lading.bill_of_lading_list);
  }
}
